import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { clientFetch } from '~/lib/.client/fetch';
import type { ReferralsInfo } from '~/routes/api.referrals.($id)';

let referralCache: ReferralsInfo | undefined = undefined;

export function useReferrals() {
  const [referrals, setReferrals] = useState<{ data?: ReferralsInfo; loading: boolean }>({
    data: referralCache,
    loading: true,
  });

  useEffect(() => {
    async function getReferrals() {
      const fingerprint = await getFingerprint();

      try {
        const response = await clientFetch('/api/referrals', {
          method: 'POST',
          body: fingerprint,
        });

        const data = await response.json<ReferralsInfo>();

        referralCache = data;

        setReferrals({
          data,
          loading: false,
        });
      } catch {
        setReferrals((prevValue) => ({
          ...prevValue,
          loading: false,
        }));

        toast.error(`Failed to fetch Referrals`);
      }
    }

    getReferrals();
  }, []);

  if (referrals.data) {
    referralCache = referrals.data;
  }

  return { ...referrals.data, loading: referrals.loading };
}

async function getFingerprint() {
  try {
    const fingerprintModule = await import('@fingerprintjs/fingerprintjs');

    const fp = await fingerprintModule.load();

    const { visitorId } = await fp.get();

    return visitorId;
  } catch {
    // do nothing
    return '';
  }
}
